export const formValidationConstants = {
  PROVIDER_DETAILS: {
    NAME: "Name is required.",
    SPECIALTY: "Specialty is required.",
  },
};
